module.exports = __webpack_public_path__ + "img/5908409ceffbcddeac73f82c6cf5f25d.png";